<script setup>
import CFIcon from '@/ui/Icon/CFIcon.vue';

defineProps({
    item: {
        type: Object,
        required: true,
    },
});
</script>

<template>
    <RouterLink
        v-slot="{ isActive, href, navigate }"
        :to="item.href"
        custom
    >
        <a
            :class="[isActive ? 'active lg:border-b-white' : 'border-b-grey-darker']"
            :href="href"
            :target="item.newTab ? '_blank' : undefined"
            :rel="item.newTab ? 'noopener' : undefined"
            class="nav-link"
            @click="item.newTab ? undefined : navigate($event)"
        >
            <CFIcon
                :name="item.icon"
                class="icon shrink-0 text-white"
            />
            <span class="label">{{ item.name }}</span>
        </a>
    </RouterLink>
</template>
